var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"svg-fill","fill":"#FFF","fillRule":"evenodd","d":"M215.018036,9.20261935 C214.747877,8.93246022 214.310366,8.93246022 214.040207,9.20261935 L211.209069,12.033758 L205.418627,17.8241996 L201.180448,13.5860205 C200.910289,13.3158614 200.472778,13.3158614 200.202619,13.5860205 C199.93246,13.8561796 199.93246,14.2941509 200.202619,14.5638491 L204.929482,19.2907119 C205.064562,19.4257915 205.241594,19.4935618 205.418627,19.4935618 C205.59566,19.4935618 205.772231,19.4257915 205.907311,19.2907119 L212.186897,13.0115866 L215.018036,10.1804479 C215.288195,9.91074979 215.288195,9.47231747 215.018036,9.20261935","transform":"translate(-200 -9)"}));
}

Check.defaultProps = {"width":"16","height":"11","viewBox":"0 0 16 11"};

module.exports = Check;

Check.default = Check;
